import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import type { ImageResult } from '../../types';
import { BlurHashDirective } from '../..//components/blurhash-placeholder/blurhash.directive';
import { TranslateModule } from '@ngx-translate/core';
import { IMAGE_UTMS } from '@sites/images/src/app/constants';

@Component({
    selector: 'sp-image-preview',
    template: `
        <div class="preview-wrapper" *ngIf="image">
            <div class="preview-container" [class.vertical]="isVertical" [class.horizontal]="!isVertical">
                <img
                    [spBlurhashImage]="image"
                    [size]="'full'"
                    [alt]="image.description"
                    class="preview-image"
                    (load)="onImageLoad($event)"
                />
                <div class="metadata">
                    <h3 class="image-title">{{ image.description }}</h3>
                    <p class="image-author">
                        <a [href]="image.links.html + IMAGE_UTMS" target="_blank">{{ 'photo' | translate }}</a>
                        {{ 'image_by' | translate }}
                        <a [href]="image.authorUrl + IMAGE_UTMS" target="_blank">{{ image.authorName }}</a>
                    </p>
                </div>
            </div>
        </div>
    `,
    styles: [
        `
            .preview-wrapper {
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .preview-container {
                position: relative;
                max-width: 90vw;
                max-height: 65vh;
                margin: auto;
                background: rgba(0, 0, 0, 0.8);
                border-radius: 4px;
                overflow: hidden;
            }

            .preview-container.vertical {
                width: auto;
                height: 65vh;
            }

            .preview-container.horizontal {
                width: 90vw;
                height: auto;
            }

            .preview-image {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: cover;
            }

            .metadata {
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                padding: 16px;
                background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));
                color: white;
            }

            .image-title {
                margin: 0;
                font-size: 18px;
                font-weight: 500;
                margin-bottom: 8px;
            }

            .image-author {
                margin: 0;
                font-size: 14px;
                opacity: 0.8;

                a {
                    color: white;
                    text-decoration: underline;
                }
            }
        `,
    ],
    imports: [CommonModule, BlurHashDirective, TranslateModule],
})
export class ImagePreviewComponent {
    @Input() image?: ImageResult;
    public isVertical = false;
    public IMAGE_UTMS = IMAGE_UTMS;

    public onImageLoad(event: Event) {
        const img = event.target as HTMLImageElement;
        this.isVertical = img.naturalHeight > img.naturalWidth;
    }
}
